import * as ambassadorWixMembersV3Follow from './members-v3-follow-member-followers.http.js';
import * as ambassadorWixMembersV3FollowTypes from './members-v3-follow-member-followers.types.js';
import * as ambassadorWixMembersV3FollowUniversalTypes from './members-v3-follow-member-followers.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function followMember(): __PublicMethodMetaInfo<
  'POST',
  { memberId: string },
  ambassadorWixMembersV3FollowUniversalTypes.FollowMemberRequest,
  ambassadorWixMembersV3FollowTypes.FollowMemberRequest,
  ambassadorWixMembersV3FollowUniversalTypes.FollowMemberResponse,
  ambassadorWixMembersV3FollowTypes.FollowMemberResponse
> {
  const payload = { memberId: ':memberId' } as any;

  const getRequestOptions = ambassadorWixMembersV3Follow.followMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/followers/{memberId}',
    pathParams: { memberId: 'memberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unfollowMember(): __PublicMethodMetaInfo<
  'DELETE',
  { memberId: string },
  ambassadorWixMembersV3FollowUniversalTypes.UnfollowMemberRequest,
  ambassadorWixMembersV3FollowTypes.UnfollowMemberRequest,
  ambassadorWixMembersV3FollowUniversalTypes.UnfollowMemberResponse,
  ambassadorWixMembersV3FollowTypes.UnfollowMemberResponse
> {
  const payload = { memberId: ':memberId' } as any;

  const getRequestOptions =
    ambassadorWixMembersV3Follow.unfollowMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/followers/{memberId}',
    pathParams: { memberId: 'memberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listCurrentMemberFollowing(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMembersV3FollowUniversalTypes.ListMyMemberFollowingRequest,
  ambassadorWixMembersV3FollowTypes.ListMyMemberFollowingRequest,
  ambassadorWixMembersV3FollowUniversalTypes.ListMyMemberFollowingResponse,
  ambassadorWixMembersV3FollowTypes.ListMyMemberFollowingResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV3Follow.listMyMemberFollowing(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/followers/my/following',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listMemberFollowing(): __PublicMethodMetaInfo<
  'GET',
  { memberId: string },
  ambassadorWixMembersV3FollowUniversalTypes.ListMemberFollowingRequest,
  ambassadorWixMembersV3FollowTypes.ListMemberFollowingRequest,
  ambassadorWixMembersV3FollowUniversalTypes.ListMemberFollowingResponse,
  ambassadorWixMembersV3FollowTypes.ListMemberFollowingResponse
> {
  const payload = { memberId: ':memberId' } as any;

  const getRequestOptions =
    ambassadorWixMembersV3Follow.listMemberFollowing(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/followers/{memberId}/following',
    pathParams: { memberId: 'memberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listCurrentMemberFollowers(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMembersV3FollowUniversalTypes.ListMyMemberFollowersRequest,
  ambassadorWixMembersV3FollowTypes.ListMyMemberFollowersRequest,
  ambassadorWixMembersV3FollowUniversalTypes.ListMyMemberFollowersResponse,
  ambassadorWixMembersV3FollowTypes.ListMyMemberFollowersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV3Follow.listMyMemberFollowers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/followers/my',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listMemberFollowers(): __PublicMethodMetaInfo<
  'GET',
  { memberId: string },
  ambassadorWixMembersV3FollowUniversalTypes.ListMemberFollowersRequest,
  ambassadorWixMembersV3FollowTypes.ListMemberFollowersRequest,
  ambassadorWixMembersV3FollowUniversalTypes.ListMemberFollowersResponse,
  ambassadorWixMembersV3FollowTypes.ListMemberFollowersResponse
> {
  const payload = { memberId: ':memberId' } as any;

  const getRequestOptions =
    ambassadorWixMembersV3Follow.listMemberFollowers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/followers/{memberId}',
    pathParams: { memberId: 'memberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryCurrentMemberConnections(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV3FollowUniversalTypes.QueryMyMemberConnectionsRequest,
  ambassadorWixMembersV3FollowTypes.QueryMyMemberConnectionsRequest,
  ambassadorWixMembersV3FollowUniversalTypes.QueryMyMemberConnectionsResponse,
  ambassadorWixMembersV3FollowTypes.QueryMyMemberConnectionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV3Follow.queryMyMemberConnections(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/followers/my/connections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryMemberConnections(): __PublicMethodMetaInfo<
  'POST',
  { memberId: string },
  ambassadorWixMembersV3FollowUniversalTypes.QueryMemberConnectionsRequest,
  ambassadorWixMembersV3FollowTypes.QueryMemberConnectionsRequest,
  ambassadorWixMembersV3FollowUniversalTypes.QueryMemberConnectionsResponse,
  ambassadorWixMembersV3FollowTypes.QueryMemberConnectionsResponse
> {
  const payload = { memberId: ':memberId' } as any;

  const getRequestOptions =
    ambassadorWixMembersV3Follow.queryMemberConnections(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/followers/{memberId}/connections',
    pathParams: { memberId: 'memberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
